export function getFilePathInfo(filePath: string) {
  if (!filePath) {
    return { fileName: "", folderPath: "", fileExtension: "" };
  }

  const parts = filePath.split(/[/\\]/);

  const fileName = parts.pop() ?? "";

  const folderPath = parts.length > 0 ? parts.join("\\") : "";

  const fileExtension = fileName.includes(".")
    ? fileName.substring(fileName.lastIndexOf(".") + 1)
    : "";

  return { fileName, folderPath, fileExtension };
}

export function getImageUploadPath(fullPath: string): string {
  const pathList = (fullPath ?? "").split("/").filter(Boolean).reverse();
  const uploadPath = pathList.length === 3 ? `${pathList[1]}/${pathList[0]}` : pathList[0];
  return uploadPath;
}
